import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import type {
  ReportDashboardComponent,
  ReportDashboardComponentCreateRequest,
  ReportsComponentHttpClientService,
} from '@core/reports-types';

export abstract class ReportsComponentsHttpClientBase implements ReportsComponentHttpClientService {
  public createOne(
    dashboardId: number,
    component: ReportDashboardComponentCreateRequest,
  ): Observable<{ component: ReportDashboardComponent }> {
    throw new Error('Method not implemented.');
  }

  public updateOne(
    dashboardId: number,
    component: ReportDashboardComponent,
  ): Observable<{ component: ReportDashboardComponent }> {
    throw new Error('Method not implemented.');
  }

  public updateGridProps(
    dashboardId: number,
    components: Array<Pick<ReportDashboardComponent, 'id' | 'grid'>>,
  ): Observable<{ components: ReportDashboardComponent[] }> {
    throw new Error('Method not implemented.');
  }

  public removeOne(
    dashboardId: number,
    componentId: number | string,
  ): Observable<{ component: ReportDashboardComponent }> {
    throw new Error('Method not implemented.');
  }
}

@Injectable()
export class ReportsComponentsHttpClient
  extends ReportsComponentsHttpClientBase
  implements ReportsComponentHttpClientService {}
